import { DefaultService } from "@/api/generated";
import { useAppStore } from "@/stores";
import { ICommunityFactorySchema } from "@/utils/types";
import {
  AffiliationTreasury,
  CommunityFactory,
  initCommunityFactory,
} from "bctsl-sdk";
import { storeToRefs } from "pinia";
import { useAeppSdk } from "./aeppSdk";
import { AeSdk, AeSdkAepp } from "@aeternity/aepp-sdk";

export function useCommunityFactory() {
  const { activeFactorySchema } = storeToRefs(useAppStore());
  const { getAeSdk } = useAeppSdk();

  async function getFactory(
    _sdk?: AeSdkAepp | AeSdk
  ): Promise<CommunityFactory> {
    const _factorySchema = await loadFactorySchema();
    const sdk = _sdk ?? (await getAeSdk());
    return initCommunityFactory(sdk, _factorySchema.address);
  }

  async function getAffiliationTreasury(
    sdk?: AeSdkAepp | AeSdk
  ): Promise<AffiliationTreasury> {
    const factory = await getFactory(sdk);
    return factory.affiliationTreasury();
  }

  async function loadFactorySchema(): Promise<ICommunityFactorySchema> {
    const result = await DefaultService.getFactory();
    activeFactorySchema.value = result;
    return result;
  }

  return {
    getAffiliationTreasury,
    activeFactorySchema,
    getFactory,
    loadFactorySchema,
  };
}
